// Terms full-text reader modal strings — EN + TR.
//
// Used by `features/onboarding/TermsFullTextModal.tsx` (the dismissible
// popup that shows the full agreement text on top of the terms / KVKK gates).
// The agreement content itself and its version status come from the backend
// and are not translated here.

import type { LocalizedDict } from '../index'

type TermsFullTextStrings = {
  versionLine: (version: string | number, status: string) => string
  languageGroupLabel: string
  loading: string
  loadError: string
}

export const termsFullTextI18n: LocalizedDict<TermsFullTextStrings> = {
  en: {
    versionLine: (version, status) => `Version ${version} · ${status}`,
    languageGroupLabel: 'Language',
    loading: 'Loading the agreement…',
    loadError: 'The agreement text could not be loaded. Please close and try again.',
  },
  tr: {
    versionLine: (version, status) => `Sürüm ${version} · ${status}`,
    languageGroupLabel: 'Dil',
    loading: 'Sözleşme yükleniyor…',
    loadError: 'Sözleşme metni yüklenemedi. Lütfen kapatıp tekrar deneyin.',
  },
}
